module.exports = __webpack_public_path__ + "img/PlusCircle-blue.5a5e30e6.svg";